/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SegmentStatistic
 */
export interface SegmentStatistic {
    /**
     * 
     * @type {SegmentStatisticPeriodEnum}
     * @memberof SegmentStatistic
     */
    period: SegmentStatisticPeriodEnum;
    /**
     * 
     * @type {SegmentStatisticStatusEnum}
     * @memberof SegmentStatistic
     */
    status: SegmentStatisticStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof SegmentStatistic
     */
    count: number;
}


/**
 * @export
 */
export const SegmentStatisticPeriodEnum = {
    Q1: 'Q1',
    Q2: 'Q2',
    Q3: 'Q3',
    Q4: 'Q4',
    Hy: 'HY'
} as const;
export type SegmentStatisticPeriodEnum = typeof SegmentStatisticPeriodEnum[keyof typeof SegmentStatisticPeriodEnum];

/**
 * @export
 */
export const SegmentStatisticStatusEnum = {
    Open: 'Open',
    Completed: 'Completed',
    NeedsReview: 'NeedsReview'
} as const;
export type SegmentStatisticStatusEnum = typeof SegmentStatisticStatusEnum[keyof typeof SegmentStatisticStatusEnum];


/**
 * Check if a given object implements the SegmentStatistic interface.
 */
export function instanceOfSegmentStatistic(value: object): value is SegmentStatistic {
    if (!('period' in value) || value['period'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function SegmentStatisticFromJSON(json: any): SegmentStatistic {
    return SegmentStatisticFromJSONTyped(json, false);
}

export function SegmentStatisticFromJSONTyped(json: any, ignoreDiscriminator: boolean): SegmentStatistic {
    if (json == null) {
        return json;
    }
    return {
        
        'period': json['period'],
        'status': json['status'],
        'count': json['count'],
    };
}

export function SegmentStatisticToJSON(json: any): SegmentStatistic {
    return SegmentStatisticToJSONTyped(json, false);
}

export function SegmentStatisticToJSONTyped(value?: SegmentStatistic | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'period': value['period'],
        'status': value['status'],
        'count': value['count'],
    };
}

